import { Point } from "../../maths/Point";
import { Rectangle } from "../../maths/Rectangle";
import { Cache_Info } from "../../renders/SpriteCache";
import { Pool } from "../../utils/Pool";
export class CacheStyle {
    constructor() {
        this.renderTexOffx = 0;
        this.renderTexOffy = 0;
        this.cacheInfo = new Cache_Info();
        this.reset();
    }
    onInvisible() {
    }
    set renderTexture(rt) {
        if (this._renderTexture && rt != this._renderTexture) {
            this._renderTexture.destroy();
        }
        this._renderTexture = rt;
    }
    get renderTexture() {
        return this._renderTexture;
    }
    recover() {
        if (this === CacheStyle.EMPTY)
            return;
        Pool.recover("SpriteCache", this.reset());
    }
    reset() {
        this.userSetCache = "none";
        this.staticCache = false;
        this.mask = null;
        this.maskParent = null;
        this.cacheRect = null;
        this.cacheInfo.reset();
        return this;
    }
    static create() {
        return Pool.getItemByClass("SpriteCache", CacheStyle);
    }
    _calculateCacheRect(sprite, tCacheType, x, y) {
        var _cacheStyle = sprite._getCacheStyle();
        if (!_cacheStyle.cacheRect)
            _cacheStyle.cacheRect = new Rectangle();
        var tRec;
        if (tCacheType === "bitmap") {
            tRec = sprite.getSelfBounds();
            tRec.width = tRec.width;
            tRec.height = tRec.height;
            tRec.x = tRec.x - sprite.pivotX;
            tRec.y = tRec.y - sprite.pivotY;
            tRec.x = Math.floor(tRec.x + x) - x;
            tRec.y = Math.floor(tRec.y + y) - y;
            tRec.width = Math.floor(tRec.width);
            tRec.height = Math.floor(tRec.height);
            _cacheStyle.cacheRect.copyFrom(tRec);
        }
        else {
            _cacheStyle.cacheRect.setTo(-sprite.pivotX, -sprite.pivotY, 1, 1);
        }
        tRec = _cacheStyle.cacheRect;
        if (sprite.scrollRect) {
            var scrollRect = sprite.scrollRect;
            tRec.x -= scrollRect.x;
            tRec.y -= scrollRect.y;
        }
        CacheStyle._scaleInfo.setTo(1, 1);
        return CacheStyle._scaleInfo;
    }
}
CacheStyle.EMPTY = new CacheStyle();
CacheStyle._scaleInfo = new Point();
CacheStyle.CANVAS_EXTEND_EDGE = 16;
